/**
 * Header `x-api-key` cho các API phía server được gate bằng shared secret `EMAIL_CRAWLER_API_KEY`
 * (`createApiKeyGate` — xem `packages/server/src/api/middleware/api-key-gate.ts`): gate
 * fail-closed, thiếu env ⇒ 503, sai key ⇒ 401.
 *
 * Key lấy từ `VITE_EMAIL_CRAWLER_API_KEY` (set trong `.env` khi chạy dev, hoặc truyền lúc build
 * bundle nhúng vào host frontend); khi biến này chưa/rỗng ⇒ dùng `DEFAULT_API_KEY` để bundle không
 * cấu hình vẫn gọi được API. Trả `{}` khi URL không thuộc API được gate, để không gắn header thừa
 * lên API khác.
 */

/**
 * Mọi route crawler phía server được mount dưới segment này (`app.route('/api/email-crawler', …)`
 * trong `packages/server/index.ts`) và đều qua gate.
 */
export const EMAIL_CRAWLER_API_URL_SEGMENT = '/api/email-crawler/';

/**
 * Cấu hình BLD Reports — `GET/PUT /api/bld-reports/config` dùng chung key với crawler
 * (xem `bld-reports.routes.ts`). Các route BLD Reports khác không gate vì tab HTML/PNG mở bằng
 * `window.open` không gắn được header.
 */
export const BLD_REPORTS_CONFIG_API_URL = '/api/bld-reports/config';

const API_KEY_PROTECTED_URL_SEGMENTS = [
  EMAIL_CRAWLER_API_URL_SEGMENT,
  BLD_REPORTS_CONFIG_API_URL,
];

/**
 * Key mặc định, dùng khi bundle không được cấu hình `VITE_EMAIL_CRAWLER_API_KEY` (dev/build).
 * Phải trùng `EMAIL_CRAWLER_API_KEY` của server — xem `packages/server/.env.example`. Giá trị
 * này nằm trong JS của bundle nên ai xem cũng đọc được.
 */
export const DEFAULT_API_KEY = '8d3cea9539b25f45c801ae918941ebc6ea40d0f953eeef7d';

export function apiKeyHeaders(url: string | undefined): Record<string, string> {
  if (!url || !API_KEY_PROTECTED_URL_SEGMENTS.some((segment) => url.includes(segment))) {
    return {};
  }
  const apiKey = (import.meta.env['VITE_EMAIL_CRAWLER_API_KEY'] ?? '').trim() || DEFAULT_API_KEY;
  return apiKey ? { 'x-api-key': apiKey } : {};
}
